import { render } from "./CorporateInformation.vue?vue&type=template&id=3d9c997c"
import script from "./CorporateInformation.vue?vue&type=script&lang=js"
export * from "./CorporateInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__